export enum CustomDataKeys {
  MARKETING_SOURCE = 'marketing source',
  MARKETING_CHANNEL = 'marketing channel',
  SOURCE_CATEGORY = 'source category',
  KEYWORD = 'keyword',
  LANDING_PAGE = 'landing page',
  REFERRER = 'referrer',
  UTM_CAMPAIGN = 'utm campaign',
  UTM_MEDIUM = 'utm medium',
  UTM_CONTENT = 'utm content',
  BROWSER = 'browser',
  OPERATOR_SYSTEM = 'operating system',
  DEVICE = 'device',
  UTM_SOURCE = 'utm source',
  UTM_ID = 'utm id',
  CAMPAIGN_ID = 'campaign id'
}
